import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthCheck = () => {
    const navigate = useNavigate();

    const isTokenExpired = (token) => {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const now = Math.floor(Date.now() / 1000);
            return payload.exp < now;
        } catch (e) {
            return true;
        }
    };

    const checkAuth = () => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');

        if (!token || !user) {
            clearAndRedirect();
            return;
        }

        if (isTokenExpired(token)) {
            console.log('Token expired, logging out...');
            clearAndRedirect();
        }
    };

    const clearAndRedirect = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
        // Agar analytics ya other data hai toh wo bhi clear karo
        navigate('/login?expired=true', { replace: true });
    };

    useEffect(() => {
        checkAuth();

        window.addEventListener('popstate', checkAuth);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') checkAuth();
        });
        
        const interval = setInterval(checkAuth, 5 * 60 * 1000);

        return () => {
            window.removeEventListener('popstate', checkAuth);
            document.removeEventListener('visibilitychange', checkAuth);
            clearInterval(interval);
        };
    }, [navigate]);
};